import { render, staticRenderFns } from "./DroneAi.vue?vue&type=template&id=b8cd6c12&scoped=true&"
import script from "./DroneAi.vue?vue&type=script&lang=ts&"
export * from "./DroneAi.vue?vue&type=script&lang=ts&"
import style0 from "./DroneAi.vue?vue&type=style&index=0&id=b8cd6c12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cd6c12",
  null
  
)

export default component.exports